var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eda-value",class:{'eda-value--invisible': !_vm.visible, 'eda-value-no-max': !_vm.maxHeight}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }